import { Outlet, RouterProvider } from "react-router-dom";

import MainContainer from "components/MainContainer/MainContainer";
import RouteHead from "seo/RouteHead";

import routes from "utils/constants/routes";
import { AuthProvider } from "context/AuthContext";
import { RequestDemoProvider } from "context/RequestDemoModalContext";

import "./index.css";

function RootLayout() {
  return (
    <MainContainer>
      <RouteHead />
      <Outlet />
    </MainContainer>
  )
}

// One layout route wraps every page, so the navbar, footer and modals live
// inside the router (they can read the current location on the server too).
export const appRoutes = [
  {
    element: <RootLayout />,
    children: routes,
  },
]

// Context providers shared by the browser (index.js) and the prerenderer (ssr/entry.js).
export function AppProviders({ children }) {
  return (
    <AuthProvider>
      <RequestDemoProvider>
        {children}
      </RequestDemoProvider>
    </AuthProvider>
  )
}

export default function App({ router }) {
  return (
    <AppProviders>
      <RouterProvider
        router={router}
        fallbackElement={<p>Loading...</p>}
      />
    </AppProviders>
  )
}
